(function (window, angular, undefined) {
    angular.module('formApp')
        .directive('anzContactNumber', [function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, element, attr, ngModel) {
                    ngModel.$parsers.push(function (value) {
                        return value.replace(/\s/g,'');
                    });
                }
            };
        }]);
})(window, window.angular);